export default {
  default: () => import("/home/circleci/project/src/layouts/default.vue").then(m => m.default || m)
}